import type { UrlTabConfig } from "~/helpers/tabs-helpers";
import { PERMISSIONS } from "~/composables/usePermissions";
export const useUrlTabsTenancy = () => {
  const t = useTranslator();

  const hasSalesPermission = useHasPermissions(PERMISSIONS.PORTFOLIO_SALES_READ_ORG);
  const hasValuationsPermission = useHasPermissions(PERMISSIONS.PORTFOLIO_VALUATIONS_READ_ORG);

  return computed<UrlTabConfig[]>(() => [
    { tabKey: "overview", labelKey: "PORTFOLIO_TENANCY_OVERVIEW", default: true },
    { tabKey: "tenant", labelKey: "PORTFOLIO_TENANCY_TENANT" },
    { tabKey: "capexes", labelKey: "PORTFOLIO_TENANCY_CAPEX" },
    { tabKey: "sales", labelKey: "PORTFOLIO_TENANCY_SALES", disabled: !hasSalesPermission.result.value },
    { tabKey: "valuations", labelKey: "PORTFOLIO_TENANCY_VALUATIONS", disabled: !hasValuationsPermission.result.value },
  ]);
};
